var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgItemsPage = function SvgItemsPage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.688 1c.78 0 1.5.469 1.812 1.219l1.313 2.906c.124.25.187.531.187.813V13c0 1.125-.906 2-2 2H3c-1.125 0-2-.875-2-2V5.937c0-.28.031-.562.156-.812L2.47 2.219A1.965 1.965 0 0 1 4.28 1zm0 1H8.5v3h5.156l-1.062-2.406A1 1 0 0 0 11.688 2M14 6H2v7c0 .563.438 1 1 1h10c.531 0 1-.438 1-1zM2.312 5H7.5V2H4.281a1 1 0 0 0-.906.594z"
  })));
};
export default SvgItemsPage;